export const DEFAULT_ORG_DETAIL_VIEWS = [
  'recommendations',
  'squad-scorecard',
  'org-trends',
];

const SCORECARD_ELIGIBLE_ASSESSMENT_TYPES = new Set(['survey', 'live']);
const INSIGHTS_ELIGIBLE_ASSESSMENT_TYPES = new Set([
  'survey',
  'live',
  'live-assessment',
]);

export function resolveOrgDetailViews(
  configured = [],
  { isRubric, templateType, assessmentType } = {}
) {
  let views = configured.map((view) =>
    view === 'analyze' ? 'insights' : view
  );
  views = views.filter((view, index) => views.indexOf(view) === index);

  if (isRubric) {
    views = views.includes('org-trends') ? views : [...views, 'org-trends'];
  } else {
    const type = templateType ?? assessmentType;

    if (SCORECARD_ELIGIBLE_ASSESSMENT_TYPES.has(type)) {
      if (!views.includes('squad-scorecard')) {
        views = [...views, 'squad-scorecard'];
      }
    }

    if (!views.includes('org-trends')) {
      views = [...views, 'org-trends'];
    }
  }

  if (shouldIncludeInsights({ isRubric, templateType, assessmentType })) {
    if (!views.includes('insights')) {
      views = [...views, 'insights'];
    }
  }

  return views;
}

function shouldIncludeInsights({ isRubric, templateType, assessmentType }) {
  if (isRubric) {
    return true;
  }

  const type = templateType ?? assessmentType;
  return INSIGHTS_ELIGIBLE_ASSESSMENT_TYPES.has(type);
}
